<template>
  <v-container fluid>
    <v-layout row class="mb-2">
      <v-progress-circular
        color="primary"
        v-if="fetchCountLoading"
        indeterminate
      ></v-progress-circular>
      <v-flex xs12 md6 lg12 v-else>
        <span class="headline">今日進件量：{{ financeCountInfo.today }}</span>
        /
        <span class="headline"
          >{{ new Date().getMonth() + 1 }}月進件量：{{
            financeCountInfo.month
          }}</span
        >
      </v-flex>
    </v-layout>
    <list-editor
      :column-keys="columnKeys"
      :items="items"
      :loading="loading"
      :showSearchBar="true"
      :showAddButton="true"
      :show-export-button="true"
      :show-search-date="true"
      :showSearchDate="true"
      :startDate="searchInfo.startDate"
      :endDate="searchInfo.endDate"
      :totalItems="getTotalItems"
      :searchPlaceHolder="searchPlaceHolder"
      :sourceName="sourceName"
      :getSearchKeys="searchKeys"
      @addData="addData"
      @editData="edit"
      @printData="printData"
      @changePage="changePage"
      @saveData="save"
      @removeData="removeData"
      @searchData="searchData"
      @exportData="exportData"
      @priorityData="priorityData"
    >
    </list-editor>

    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      @confirmEvent="messageDialog.confirm"
    >
    </alert-view>

    <!--其他工具-彈窗-->
    <FinanceCreditDialog
      :item="editedItem"
      :visible="toolDialog.visible"
      :platform="3"
      @showEvent="toolEvent"
      @closeEvent="toolDialog.visible = false"
      @confirmEvent="toolDialog.visible = false"
    ></FinanceCreditDialog>

     <!--列印-彈窗-->
    <PrintDialog :visible="printDialog.visible"
                 :item="editedItem"
                 :width="isMobile ? '90%' : '50%'"
                 @showEvent="printCreditView"
                 @confirmEvent="printDialog.visible = false">
    </PrintDialog>

    <!--更新案編-->
    <v-dialog
      v-model="updateDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-text>
          <v-text-field v-model="updateDialog.displayId" :label="`裕富案件編號`"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red" dark text @click="updateDialog.cancel">取消</v-btn>
          <v-btn class="primary" dark text @click="updateDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <agent-contract-view
      :agent-contract-dialog="agentContractDialog"
      @saveContract="saveContract"
    ></agent-contract-view>

     <!--案件對保資料-->
    <v-dialog
      v-model="insureDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>案件對保資料</h3>
        </v-card-title>
        <v-card-text>
          <case-insure-view
            :item-detail="editedItem"
            :show="insureDialog.visible"
            @saveEvent="insureDialog.confirm"
            @cancelEvent="insureDialog.cancel"
          ></case-insure-view>
        </v-card-text>
      </v-card>
    </v-dialog>
    <installment-payment-dialog
      :title="installmentDialog.title"
      :visible="installmentDialog.visible"
      :displayId="editedItem.displayId"
      :cellphone="editedItem.customer ? editedItem.customer.cellphone : ''"
      :editIndex="installmentDialog.editIndex"
      @closeEvent="closeDialogView"
      ></installment-payment-dialog>
    <priority-credit-view
      v-if="priorityDialog.visible"
      :item="rowItemInfo"
      :visible="priorityDialog.visible"
      @closeDialog="priorityDialog.cancel"
      @onFinishUpload="setPriceInfo"
      @onErrorMessage="priceInfoError"
      @closeEvent="closeDialogView"
    >
    </priority-credit-view>
    <!-- <v-dialog
      v-model="toolDialog.visible"
      :max-width="isMobile ? '90%' : '50%'"
    >
      <v-card>
        <v-card-title class="headline">
          {{ toolDialog.text }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap style="margin-top: 10px;">
            <v-flex xs6>
              <v-btn class="primary" dark text @click="toolEvent(1)"
                >進件</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn class="primary" dark text @click="toolEvent(5)"
                >CA申請表-套印</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn class="primary" dark text @click="toolEvent(10)"
                >修改經辦人</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="toolDialog.visible = false"
            >關閉</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <contact-dialog
      :visible="contactDialog.visible"
      @cancelEvent="contactDialog.visible = false"
      @confirmEvent="contactDialog.confirm"
    ></contact-dialog>
  </v-container>
</template>

<script>
import {
  getNow,
  exportFileToBlobUrl,
  customFormatDate,
  getCreditLoanFiles,
} from "../utils/tool";
import ListEditor from "../../components/ListEditor";
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from "vuex";
import ApplicationModel from "../../models/ApplicationModel";
import AlertView from "@/components/AlertView";
import ContactDialog from "../../components/ContactDialog";
import FinanceCreditDialog from "../../components/FinanceCreditDialog";
import PrintDialog from "./PrintDialog.vue";
import CaseInsureView from "../../components/CaseInsureView";
import installmentPaymentDialog from '../../components/InstallmentPaymentDialog';
import AgentContractView from "../../components/AgentContractView";
import PriorityCreditView from "../../components/PriorityCreditView";

const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "CaList",
  components: { ListEditor, AlertView, ContactDialog, FinanceCreditDialog, PrintDialog, CaseInsureView, installmentPaymentDialog, AgentContractView, PriorityCreditView },
  data() {
    return {
      sourceName: "CaList",
      cityData: require("../../assets/taiwan_city"),
      cityList: [],
      areaList: {},
      isMobile: md.phone(),
      loading: false,
      valid: true,
      editedIndex: -1,
      editedItem: new ApplicationModel(),
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      items: [],
      contactDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      selectAgentLoading: false,
      selectAgentId: null,
      searchAgent: null,
      agentItems: [],
      toolDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      searchInfo: {
        startDate: "",
        endDate: "",
        keyword: "",
        searchKey: "",
      },
      pageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      mortgageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      searchPlaceHolder: "搜尋身分證、姓名、電話",
      fetchCountLoading: false,
      financeCountInfo: {
        today: 0,
        month: 0,
      },
      bankName: "",
      agentContractDialog: {
        title: "",
        text: "",
        caseId: "",
        vendorName: "",
        memberName: "",
        memberId: "",
        bonus: 5,
        auto: false,
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      printDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      updateDialog: {
        title: "",
        text: "",
        caseId: "",
        displayId: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      insureDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      installmentDialog: {
        title: '',
        visible: false,
        editIndex: 0,
        confirm: () => {},
        cancel: () => {},
      },
      priorityDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      rowItemInfo: {},
    };
  },
  created() {
    const now = new Date();
    const end = new Date(now.getFullYear() + 10, now.getMonth(), now.getDate());

    this.cityData.taiwan.forEach((city) => {
      this.cityList.push(city.city);
      this.areaList[city.city] = city.area;
    });
    this.fetchAgentList().then(() => {
      this.editedItem.agentId = this.getUserInfo.agentId;
      // this.changeAgent();
    });
    this.setDefualtDate();
    this.loadData();
    this.loadFinanceCountInfo();
  },
  watch: {
    // searchAgent(val){
    //     this.querySelections(val);
    // }
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
    columnKeys() {
      let list = [
        {
          value: "tools",
          text: "編輯",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "print",
          text: "其他工具",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "name",
          text: "申辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "memberId",
          text: "身分證字號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "vendorName",
          text: "經辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "saveDate",
          text: "儲存日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "caseStatus",
          text: "案件狀態",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "category",
          text: "專案類型",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "caseType",
          text: "顧客評分",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "productName",
          text: "專案名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "applyDisplayDate",
          text: "申請日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPrice",
          text: "貸款金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "installmentsNumber",
          text: "總期數",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPriceMonth",
          text: "月付金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "createDate",
          text: "建立時間",
          sortable: true,
          required: false,
          disabled: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "approvedDisplayDate",
          text: "撥款日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "realPrice",
          text: "實際撥款金額",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "bonus",
          text: "佣金",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "settingPrice",
          text: "設定費",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "comment",
          text: "備註",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "delete",
          text: "刪除",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "edit",
          text: "編輯",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
      ];
      if (this.isAdmin) {
        return list;
      } else {
        return list.filter((m) => m.value !== "delete");
      }
    },
    dialogKeys() {
      return this.columnKeys.filter(
        (m) =>
          m.value !== "tools" && m.value !== "delete" && m.value !== "print"
      );
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    getTotalItems() {
      return this.totalItems;
    },
    searchKeys() {
      return [
        { key: "name", value: "姓名" },
        { key: "user_sn", value: "身分證字號" },
        { key: "user_cellphone", value: "電話" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "caList",
      "saveMortgageData",
      "removeMortgageData",
      "fetchCreditProductInfo",
      "deleteCaInfo",
      "saveCaContactInfo",
      "fetchAgentList",
      "getCaCountInfo",
      "getFinanceOfficialData",
      "getNotifyAppropriationList",
      'getCaseStatusLog',
      "queryAppropriation",
      "queryCaseStatus"
    ]),
    async loadFinanceCountInfo() {
      //取當日
      const date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
      const firstDay = customFormatDate(new Date(y, m, 1), "YYYY-MM-DD");
      const lastDay = customFormatDate(new Date(y, m + 1, 0), "YYYY-MM-DD");
      const query = {
        agentId: this.isAdmin
          ? ""
          : this.getUserInfo.agentId
          ? this.getUserInfo.agentId
          : "",
        start: `${firstDay} 00:00:00`,
        end: `${lastDay} 23:59:59`,
      };
      console.log(query);

      this.fetchCountLoading = true;
      const res = await this.getCaCountInfo(query);
      this.fetchCountLoading = false;
      if (res && res.data) {
        const info = res.data.data;
        this.financeCountInfo.today = info.count;
        this.financeCountInfo.month = info.rangeCount;
      }
    },
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.searchInfo.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.searchInfo.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    async toolEvent(index) {
      this.toolDialog.visible = false;
      console.log(`toolEvent === ${index}`);
      console.log(`toolEvent === ${JSON.stringify(this.editedItem)}`)
      // if (index === 1) {
      //   const routeData = this.$router.resolve({
      //     name: "CreditProductPrint",
      //     query: {
      //       caseId: this.editedItem.caseId,
      //       caseCategory: 2,
      //       isPrint: true
      //     }
      //   });
      //   window.open(routeData.href, "_blank");
      // }
      // if (index === 5) {
      //   const routeData = this.$router.resolve({
      //     name: "CreditProductPrint",
      //     query: {
      //       caseId: this.editedItem.caseId,
      //       caseCategory: 2,
      //       isPrint: false
      //     }
      //   });
      //   window.open(routeData.href, "_blank");
      // } else if (index === 10) {
      //   this.contactDialog.visible = true;

      //   this.contactDialog.confirm = (selectAgentId) => {
      //     console.log(`selectAgentId ${selectAgentId}`)
      //     const find = this.getAgentList.find(
      //       agent => agent.agentId === selectAgentId
      //     );
      //     if (find) {
      //       const postData = {
      //         caseId: this.editedItem.caseId,
      //         agentId: find.agentId,
      //         vendorName: find.displayName
      //       };
      //       console.log(postData)
      //       this.changeContact(postData);
      //     }
      //     this.contactDialog.visible = false;
      //   };
      // }
      if (index === 0) {
        this.printDialog.visible = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      }
      if (index === 1) {
        const officialItem = await this.getFinanceOfficialData({
          caseId: this.editedItem.caseId,
        });
        console.log(`officialItem === ${JSON.stringify(officialItem)}`);
        if (officialItem) {
          const bankInfo = this.getBankInfo(
            officialItem.bankId,
            officialItem.bankSubId
          );
          console.log(`getBankInfo === ${JSON.stringify(bankInfo)}`);
          this.editedItem.bankName = bankInfo.branch;
          this.bankName = bankInfo.branch;
          const find = bankInfo.child.find(
            (item) =>
              item.code === `${officialItem.bankId}${officialItem.bankSubId}`
          );
          if (find) {
            this.editedItem.bankSubName = find.branch;
            this.bankSubName = find.branch;
          }
        }

        const creditLoanFiles = getCreditLoanFiles(this.editedItem);
        if (creditLoanFiles.length > 0) {
          creditLoanFiles.forEach((item) => {
            this.attachmentFile.attachmentFiles.push(item);
          });
        }

        this.pageDialog.visible = true;
        this.pageDialog.confirm = () => {
          this.pageDialog.visible = false;
        };
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      }

      if (index === 2) {
        this.uploadDialog = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 3) {
        this.uploadFileDialog = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 4) {
        // 原融
        this.showFinanceOfficialView = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 15) {
        // 商品貸
        this.showCA20 = true;
        this.showFinanceOfficialView = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 5) {
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.agentContractDialog.visible = false;

        // this.$set('newMortgageItem' , );
        this.newMortgageItem = {
          profileId: Math.uuidFast(),
          parentAgent: this.editedItem.parentAgent,
          parentAgentName: this.editedItem.parentAgent.displayName,
          publishDate: "",
          name: this.editedItem.customer.name,
          memberId: this.editedItem.customer.memberId,
          engineId: "",
          startDate: {
            year: "",
            month: "",
            day: "",
            disabled: false,
            isRepublic: true,
          },
          endDate: {
            year: "",
            month: "",
            day: "",
            disabled: false,
            isRepublic: true,
          },
          creditPrice: this.editedItem.vendor.totalCreditPrice,
          createDate: getNow(),
          comment: "",
          city: "",
          area: "",
          address: this.editedItem.customer.home.residenceAddress,
          carYear: "",
          carType: "",
          carId: "",
          carEngineType: "",
          birthday: {
            year: this.editedItem.customer.birthdayInfo.year,
            month: this.editedItem.customer.birthdayInfo.month,
            day: this.editedItem.customer.birthdayInfo.day,
            disabled: false,
            isRepublic: true,
          },
          station: "",
        };
        console.log(
          `showMortgageDialog ${JSON.stringify(this.newMortgageItem)}`
        );
        this.mortgageDialog.visible = true;
        this.mortgageDialog.confirm = () => {
          this.mortgageDialog.visible = false;
          this.showMessageDialog(
            "儲存成功",
            "動產抵押契約書儲存成功",
            true,
            () => {},
            () => {}
          );
        };
        this.mortgageDialog.cancel = () => {
          this.mortgageDialog.visible = false;
        };
      } else if (index === 6) {
        this.mortgageDialog.visible = false;
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.agentContractDialog.visible = true;
        this.agentContractDialog.caseId = this.editedItem.caseId;
        this.agentContractDialog.memberId = this.editedItem.memberId;
        this.agentContractDialog.memberName = this.editedItem.name;
        this.agentContractDialog.cancel = () => {
          this.agentContractDialog.visible = false;
        };
      } else if (index === 7) {
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
        this.updateDialog.visible = true;
        this.updateDialog.confirm = async () => {
          this.updateDialog.visible = false;

          if (this.updateDialog.displayId === "") {
            return;
          }

          await this.updateCaseId({
            caseId: this.editedItem.caseId,
            displayId: this.updateDialog.displayId,
          });

          this.showMessageDialog(
            "儲存成功",
            "更新案編儲存成功",
            true,
            () => {},
            () => {}
          );
        };
        this.updateDialog.cancel = () => {
          this.updateDialog.visible = false;
        };
      } else if (index === 8) {
        //對保資料
        this.toolDialog.visible = false;
        this.insureDialog.visible = true;
        this.insureDialog.confirm = () => {
          this.insureDialog.visible = false;
          this.loadData();
        };
        this.insureDialog.cancel = () => {
          this.insureDialog.visible = false;
        };
      } else if (index === 9) {
        //設定資料
        this.toolDialog.visible = false;
        this.settingDialog.visible = true;
        console.log(`settingDialog === ${this.settingDialog.visible}`);
        this.settingDialog.confirm = () => {
          this.settingDialog.visible = false;
          this.loadData();
        };
        this.settingDialog.cancel = () => {
          this.settingDialog.visible = false;
        };
      } else if (index === 10) {
        this.contactDialog.visible = true;

        this.contactDialog.confirm = (selectAgentId) => {
          const find = this.getAgentList.find(
            (agent) => agent.agentId === selectAgentId
          );
          if (find) {
            const postData = {
              caseId: this.editedItem.caseId,
              agentId: find.agentId,
              contactPhone: find.cellphone,
              contactName: find.displayName,
            };
            this.changeContact(postData);
          }
          this.contactDialog.visible = false;
        };
      } else if (index === 13) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isEdit: true,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (index === 14) {
        this.toolDialog.visible = false;
        this.priorityDialog.visible = true;
        this.priorityDialog.confirm = () => {
          this.priorityDialog.visible = false;
        };
        this.priorityDialog.cancel = () => {
          this.priorityDialog.visible = false;
        };
      } else if (index === 17) {
        this.toolDialog.visible = false;
        this.installmentDialog.title = "裕富線上請款";
        this.installmentDialog.editIndex = 0;
        this.installmentDialog.visible = true;
        this.installmentDialog.confirm = () => {
          this.installmentDialog.visible = false;
        };
        this.installmentDialog.cancel = () => {
          this.installmentDialog.visible = false;
        };
      } else if (index === 18) {
        this.toolDialog.visible = false;
        this.loading = true;
        const param = {
          salesId: this.getUserInfo.salesId ? this.getUserInfo.salesId : "",
          displayId: this.editedItem.displayId,
        };

        const result = await this.queryAppropriation(param);
        this.loading = false;
        const data = result.data;
        console.log(`裕富線上撥款狀態 === ${JSON.stringify(data)}`);
        let message = "該案件異常";
        if (data) {
          const appropriations = data.data.appropriations;

          if (appropriations.length > 0) {
            // const repayKindName = appropriations[0].repayKindName
            const status = appropriations[0].status;
            message = installmentOnlineList(status);
          }
        }

        this.showMessageDialog(
          "裕富線上撥款狀態",
          message,
          true,
          () => {},
          () => {}
        );
      } else if (index === 19) {
        this.toolDialog.visible = false;
        this.loading = true;
        const param = {
          salesId: this.getUserInfo.salesId ? this.getUserInfo.salesId : "",
          displayId: this.rowItemInfo.displayId,
          memberId: this.editedItem.memberId,
        };

        const result = await this.queryCaseStatus(param);
        this.loading = false;
        console.log(`裕富線上案件狀態查詢 === ${JSON.stringify(result)}`);
        const data = result.data;
        console.log(`裕富線上案件狀態查詢 === ${JSON.stringify(data.data)}`);
        let message = "";
        if (data.data) {
          const caseStatusItem = data.data;
          message += `${this.rowItemInfo.displayId} ${this.rowItemInfo.name} <br>`;
          message += `進件日期 ${this.editedItem.createDate}<br><br>`;
          if (caseStatusItem.payment) {
            message += `${caseStatusItem.promoName} <br>`;
            message += `總貸金額 ${caseStatusItem.instCap} <br>`;
            message += `期數 ${caseStatusItem.payment[0].instNo} <br>`;
            message += `期付 ${caseStatusItem.payment[0].instAmt} <br>`;
            if (
              caseStatusItem.promoNo === "DN81" ||
              caseStatusItem.promoNo === "DN82"
            ) {
              message += `<br>`;
              message += `預計撥付金額:<br>`;
              message += `${
                caseStatusItem.netBorrowToPayBackAmt
                  ? caseStatusItem.netBorrowToPayBackAmt
                  : "0"
              }<br>`;
              message += `預計結清金額:<br>`;
              message += `${
                caseStatusItem.borrowToPayBackAmt
                  ? caseStatusItem.borrowToPayBackAmt
                  : "0"
              }<br>`;
            }

            if (
              caseStatusItem.capitalApply &&
              caseStatusItem.capitalApply.length > 0
            ) {
              message += `<br>`;
              message += `實撥金額<br>`;
              let i = 1,
                total = 0;
              for (let price of caseStatusItem.capitalApply) {
                if (price.payeeTypeName === "裕富") {
                  message += `前貸金額<br>`;
                } else if (price.payeeTypeName === "客戶") {
                  message += `撥款新案的剩餘金額<br>`;
                } else {
                  message += `${i}<br>`;
                }
                message += `撥款日期：${price.appropriateDate}<br>`;
                message += `撥款金額：${price.remitAmount}<br>`;
                message += `<br>`;
                total += parseInt(price.remitAmount, 10);
                i++;
              }
              message += `<br>撥款總額：${total}<br>`;
            }
          } else {
            message = `尚無狀態<br>`;
          }

          if (
            caseStatusItem.reasonSuggestionDetail &&
            caseStatusItem.reasonSuggestionDetail.length > 0
          ) {
            message += `<br>`;
            const dataDetail = caseStatusItem.reasonSuggestionDetail;
            for (const i in dataDetail) {
              const dataInfo = dataDetail[i];
              if (dataInfo["kind"]) {
                message += `${dataInfo["kind"]}`;
              }
              if (dataInfo["explain"]) {
                if (dataInfo["kind"]) {
                  message += ` : `;
                }
                message += `${dataInfo["explain"]} <br>`;
              } else {
                message += `<br>`;
              }
              if (dataInfo["comment"]) {
                message += `${dataInfo["comment"]} <br>`;
              }
            }
          }
          if (caseStatusItem.examineComment && caseStatusItem.examineComment !=='') {
            message += `備註說明：${caseStatusItem.examineComment} <br>`
          }
          if (caseStatusItem.customer && caseStatusItem.customer.length > 0) {
            for (let customer of caseStatusItem.customer){
              message += `<br>`;
              message += `${customer.name} ${customer.index === 0 ? '本人': `保${customer.index}`} | ${customer.calloutResult ? customer.calloutResult.comment : ''} <br>`
            }
          }
        } else {
          message = data.message;
        }

        this.toolDialog.visible = false;
        this.showMessageDialog(
          "裕富線上案件狀態查詢",
          message,
          true,
          () => {},
          () => {}
        );
      } else if (index === 20) {
        this.toolDialog.visible = false;
        this.installmentDialog.title = "裕富線上審件補件";
        this.installmentDialog.editIndex = 1;
        this.installmentDialog.visible = true;
        this.installmentDialog.confirm = () => {
          this.installmentDialog.visible = false;
        };
        this.installmentDialog.cancel = () => {
          this.installmentDialog.visible = false;
        };
      } else if (index === 21) {
        this.toolDialog.visible = false;
        this.installmentDialog.title = "裕富線上案件申覆爭取";
        this.installmentDialog.editIndex = 2;
        this.installmentDialog.visible = true;
        this.installmentDialog.confirm = () => {
          this.installmentDialog.visible = false;
        };
        this.installmentDialog.cancel = () => {
          this.installmentDialog.visible = false;
        };
      } else if (index === 22) {
        console.log(`this.editedItem === ${JSON.stringify(this.editedItem)}}`);
        this.toolDialog.visible = false;
        this.installmentDialog.title = "裕富線上案件重新照會";
        this.installmentDialog.editIndex = 3;
        this.installmentDialog.visible = true;
        this.installmentDialog.confirm = () => {
          this.installmentDialog.visible = false;
        };
        this.installmentDialog.cancel = () => {
          this.installmentDialog.visible = false;
        };
      } else if (index === 23) {
        console.log(`this.editedItem === ${JSON.stringify(this.editedItem)}}`);
        this.toolDialog.visible = false;
        // this.examDialog.title = '裕富線上案件重新照會';
        // this.examDialog.editIndex = 3;
        this.examDialog.visible = true;
        this.examDialog.confirm = () => {
          this.examDialog.visible = false;
        };
        this.examDialog.cancel = () => {
          this.examDialog.visible = false;
        };
      } else if (index === 24) {
        // 核准通知書
        let routeData = this.$router.resolve({
          path: "/ApprovedView",
          query: {
            displayId: this.editedItem.displayId,
            salesId: this.getUserInfo.salesId,
            memberId: this.editedItem.customer.memberId,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (index === 25) {
        // 新增保人
        this.editedIndex = 0;
        const query = {
          caseCategory: this.editedItem.category,
          editIndex: 0,
          caseId: this.editedItem.caseId,
          enable: true,
          agentId: this.editedItem.agentId,
          platform: this.editedItem.platform,
          guarantor: 1, //1:新增保人的功能
        };
        console.log(` gotoCredit === ${JSON.stringify(query)}`);
        // this.$router.push({ path: '/EditCreditProduct', query });
        let routeData = this.$router.resolve({
          path: "/EditCreditProduct",
          query: query,
        });
        window.open(routeData.href, "_blank");
      } else if (index === 26) {
        // 強制查佣
        this.toolDialog.visible = false;
        await this.autoCheckBonus({
          displayId: this.editedItem.displayId,
          enable: true,
        });
      } else if (index === 27) {
        // 狀態變更紀錄
        this.toolDialog.visible = false;
        this.loading = true;
        const param = {
          displayId: this.rowItemInfo.displayId,
        };
        const result = await this.getCaseStatusLog(param);
        this.loading = false;
        const data = result.data;
        console.log(`案件狀態變更紀錄 === ${JSON.stringify(data.data)}`);

        let message = "";
        if (data.data) {
          const logs = data.data;
          message += `${this.rowItemInfo.displayId} ${this.rowItemInfo.name} <br>`;
          message += `變更紀錄 <br><br>`;
          for (let item of logs) {
            message += `狀態:${item.status} | 狀態變更時間：${item.modifyTime}<br><br>`;
          }
        } else {
          message += `查無案件狀態變更紀錄 <br>`;
        }
        this.toolDialog.visible = false;
        this.showMessageDialog(
          "案件狀態變更紀錄查詢",
          message,
          true,
          () => {},
          () => {}
        );
      } else if (index === 28) {
        // 撥款通知紀錄
        this.toolDialog.visible = false;
        this.loading = true;
        const param = {
          displayId: this.rowItemInfo.displayId,
        };
        const result = await this.getNotifyAppropriationList(param);
        this.loading = false;
        const data = result.data;
        console.log(`撥款通知紀錄 === ${JSON.stringify(data.data)}`);

        let message = "";
        if (data.data) {
          const logs = data.data;
          message += `${this.rowItemInfo.displayId} ${this.rowItemInfo.name} <br>`;
          message += `撥款通知紀錄 <br><br>`;
          for (let item of logs) {
            message += `撥款日:${item.appropriationDate} | 金額：${item.appropriationAmt}<br><br>`;
          }
        } else {
          message += `查無撥款通知紀錄 <br>`;
        }
        this.toolDialog.visible = false;
        this.showMessageDialog(
          "案件撥款通知紀錄查詢",
          message,
          true,
          () => {},
          () => {}
        );
      }
    },
    priorityData(item) {
      this.editedItem = item;
      if(!this.editedItem.platform) {
        this.editedItem.platform = 0
      }
      this.rowItemInfo = item;
      this.toolEvent(14);
    },
    printCreditView(type) {
      if (type === 0) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,

            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 1) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 2) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 3) {
        if (!this.editedItem.laonhfcInfo) {
          this.editedItem.laonhfcInfo = new LaonhfcModel();
        }
        if (!this.editedItem.paymentInfo) {
          this.editedItem.paymentInfo = new PaymentInfoModel();
        }
        if (!this.editedItem.caseInsure) {
          this.editedItem.caseInsure = new CaseInsureModel();
        }
        console.log(`uploadMotorDialog`)
        this.uploadMotorDialog = true;
      } else if (type === 4) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 5) { // CA套印
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: false,
            platform:this.editedItem.platform
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 6) {// CA列印
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: true,
            platform:this.editedItem.platform
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 7) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 7,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 8) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 8,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 9) {
        const routeData = this.$router.resolve({
          name: "EditCreditProduct",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            enable: false,
            agentId: this.getUserInfo.userId,
            editIndex: 0,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 10 || type === 11) {
        this.entrepreneurEvent(type);
      } else {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    saveContract(data) {
      console.log(`save contract == ${JSON.stringify(data)}`);
      let routeData = this.$router.resolve({
        path: "/AgentContract",
        query: {
          contractId: this.agentContractDialog.caseId,
        },
      });
      window.open(routeData.href, "_blank");
      this.agentContractDialog.visible = false;
    },
    closeDialogView() {
      // this.questionDialog.visible = false;
      // this.loanhfcDialog.visible = false;
      // this.entrepreneurDialog.visible = false;
      this.mortgageDialog.visible = false;
      this.priorityDialog.visible = false;
      // this.caDialog.visible = false;
      this.installmentDialog.visible = false;
    },
    getBankInfo(key, subId) {
      let bankCopyList = JSON.parse(JSON.stringify(bankCodeList));
      const info = bankCopyList[key];
      return info;
    },
    async changeContact(data) {
      const result = await this.saveCaContactInfo(data);
      console.log(result);
      this.loadData();
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      const beginDate = `${this.searchInfo.startDate}`;
      const tempEndDate = `${this.searchInfo.endDate}`;
      let searchQuery = [];
      if (this.searchInfo.searchKey && this.searchInfo.keyword) {
        searchQuery.push({
          key: `${this.searchInfo.searchKey}`,
          value: `${this.searchInfo.keyword}`,
        });
      }

      const results = await this.caList({
        startDate: beginDate,
        endDate: tempEndDate,
        pageIndex: this.pageIndex,
        limit: this.limit,
        searchQuery: searchQuery,
        agentId: this.isAdmin ? "" : this.getUserInfo.agentId,
      });
      this.items = results.data.data.list;
      console.log(`items === ${JSON.stringify(this.items)}`);
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
    },
    addData() {
      this.editedItem = new ApplicationModel();
      // const link = getFinanceUrl(this.getUserInfo.agentId, 2);
      // window.open(link, '_blank');
      const query = {
        caseCategory: 2,
        editIndex: -1,
        agentId: this.getUserInfo.agentId,
        platform: this.editedItem.platform, //0裕富 3高踞
        // platform: 3 //商品貸編號
      };
      let routeData = this.$router.resolve({
        path: "/EditCreditProduct",
        query: query,
      });
      window.open(routeData.href, "_blank");
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex === -1) {
          this.editedItem.parentAgent = {
            agentId: this.getUserInfo.agentId,
            agentNumber: this.getUserInfo.agentNumber,
            displayName: this.getUserInfo.displayName,
            parentAgent: this.getUserInfo.parentAgent
              ? this.getUserInfo.parentAgent
              : "",
            salesName: this.getUserInfo.salesName
              ? this.getUserInfo.salesName
              : "",
          };

          const check = this.items.find(
            (i) => i.profileId === this.editedItem.profileId
          );
          if (check) {
            this.showMessageDialog(
              "提示",
              `${this.editedItem.profileId} 資料編號重複！`,
              true,
              () => {},
              () => {}
            );
            return;
          }
        }

        this.loading = true;
        this.saveMortgageData(this.editedItem).then((error) => {
          this.loading = false;
          this.loadData();
          this.closeDialog();
        });
      }
    },
    edit(item) {
      this.editedItem = item;
      if (!this.editedItem.platform) {
        this.editedItem.platform = 0;
      }
      console.log(`edit == ${JSON.stringify(item)}`);
      this.editedIndex = 0;
      this.gotoCredit(item, 2);
    },
    gotoCredit(item, category) {
      const query = {
        caseCategory: category,
        editIndex: 0,
        caseId: item.caseId,
        enable: true,
        agentId: item.agentId,
      };
      let routeData = this.$router.resolve({
        path: "/EditCreditProduct",
        query: query,
      });
      window.open(routeData.href, "_blank");
    },
    async removeData(item) {
      this.loading = true;
      this.showMessageDialog(
        "提示",
        "是否確定要刪除？",
        true,
        async () => {
          console.log(`item.caseId ===  ${item.caseId}`);
          const res = await this.deleteCaInfo({ caseId: item.caseId });
          console.log(`res === ${JSON.stringify(res)}`);
          const result = res.data;
          if (result.statusCode != 0) {
            this.showMessageDialog(
              "錯誤",
              result.message,
              true,
              () => {},
              () => {}
            );
          }

          this.closeDialog();
        },
        () => {}
      );
    },
    async printData(item) {
      this.editedItem = item;
      this.toolDialog.visible = true;
    },
    searchData(search) {
      console.log(`searchData ${JSON.stringify(search)}`);

      this.searchInfo.startDate = search.startDate;
      this.searchInfo.endDate = search.endDate;
      this.searchInfo.keyword = search.keyword;
      this.searchInfo.searchKey = search.searchKey;
      this.loadData();
      // if (search.keyword !=='' || search.searchDate.length > 0){
      //     this.items = this.items.filter(item=>{
      //         const value = `${item.memberId}${item.name}${item.carId}`;
      //         if (search.searchDate && search.searchDate.length > 0) {
      //             const date1 = new Date(`${search.searchDate[0]} 00:00:00`).getTime();
      //             const date2 = new Date(`${search.searchDate[1]} 23:59:59`).getTime();
      //             const itemDate = new Date(item.createDate).getTime();

      //             if (search.keyword !=='') {
      //                 return value.indexOf(search.keyword) > -1 && (itemDate >= date1 && itemDate <= date2);
      //             } else {
      //                 return (itemDate >= date1 && itemDate <= date2);
      //             }
      //         }
      //         if (search.keyword !=='') {
      //             return value.indexOf(search.keyword) > -1;
      //         }
      //     })
      // } else {
      //     this.loadData();
      // }
    },
    sortSearchKeyword() {
      const keyWord = this.searchInfo.keyword
        ? this.searchInfo.keyword.trim()
        : "";
      if (keyWord) {
        this.items = this.items.filter((item) => {
          const value = `${item.memberId}${item.name}${item.carId}`;
          if (this.searchInfo.keyword !== "") {
            return value.indexOf(this.searchInfo.keyword) > -1;
          }
        });
      }
    },
    removeProfile() {
      this.showMessageDialog(
        "提示",
        "是否確定要刪除？",
        true,
        () => {
          this.removeMortgageData(this.editedItem).then((error) => {
            this.closeDialog();
          });
        },
        () => {}
      );
    },
    closeDialog() {
      this.loading = false;
      this.editedItem = new ApplicationModel();
      this.editedIndex = -1;
      this.loadData();
    },
    exportData() {
      let list = this.items;
      const columns = [
        { name: "經銷", key: "parentAgentName" },
        { name: "身分證/統一編號", key: "memberId" },
        { name: "車主名稱", key: "name" },
        { name: "出生日期", key: "birthday" },
        { name: "車主名稱", key: "name" },
        { name: "縣市", key: "city" },
        { name: "戶籍地址", key: "address" },
        { name: "契約生效日", key: "startDate" },
        { name: "契約終止日", key: "endDate" },
        { name: "期數x期付", key: "creditPrice" },
        { name: "監理所", key: "station" },
        { name: "牌照號碼", key: "carId" },
        { name: "廠牌", key: "vendorId" },
        { name: "出廠年份", key: "carYear" },
        { name: "引擎號碼/車身號碼", key: "engineId" },
        { name: "牌照類別", key: "carType" },
        { name: "型式", key: "carEngineType" },
        { name: "建立時間", key: "createDate" },
        { name: "備註", key: "comment" },
      ];
      exportFileToBlobUrl("動產抵押申請資料匯出", columns, list);
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/web/CaList.vue